import { lazy } from "react";
import { getContractTypeKey } from "../contract/create-contract/ContractTypeName";
import { ContractType } from "../contract/model/ContractViewModel";

const PrivacyPage = lazy(() => import("../about/PrivacyPage"));
const FaqPage = lazy(() => import("../about/FaqPage"));
const HowItWorksPage = lazy(() => import("../about/HowItWorksPage"));
const InstructionsPage = lazy(() => import("../about/InstructionsPage"));
const DigitalSigningPage = lazy(() => import("../about/DigitalSigningPage"));
const StaticContractsPage = lazy(() => import("../about/StaticContractsPage"));
const TermsPage = lazy(() => import("../about/TermsPage"));
const BecomeMemberPage = lazy(() => import("../membership/BecomeMemberPage"));
const MembershipPaymentPage = lazy(
  () => import("../membership/MembershipPaymentPage")
);
const CreateContractPage = lazy(
  () => import("../contract/create-contract/CreateContractPage")
);
const CreateStandardContractPage = lazy(
  () => import("../contract/create-contract/CreateStandardContractPage")
);
const CreatePremiumContractPage = lazy(
  () => import("../contract/create-contract/CreatePremiumContractPage")
);
const CreateSimpleContractPage = lazy(
  () => import("../contract/create-contract/CreateSimpleContractPage")
);
const CreateMemberContractPage = lazy(
  () => import("../contract/create-contract/CreateMemberContractPage")
);
const AboutUpgradePage = lazy(() => import("../about/AboutUpgradePage"));
const AboutOwnershipTransferPage = lazy(
  () => import("../about/AboutOwnershipTransferPage")
);

const StaticRoutes = {
  digitalSigning: {
    path: "/om/digital-signering",
    component: DigitalSigningPage,
  },
  faq: {
    path: "/om/sporsmal-og-svar",
    component: FaqPage,
  },
  howItWorks: {
    path: "/om/slik-fungerer-det",
    component: HowItWorksPage,
  },
  aboutOwnershipTransfer: {
    path: "/om/eierskifte",
    component: AboutOwnershipTransferPage,
  },
  instructions: {
    path: "/om/utfylling-av-kontrakt",
    component: InstructionsPage,
  },
  privacy: {
    path: "/om/cookies-og-personvern",
    component: PrivacyPage,
  },
  staticContracts: {
    path: "/om/last-ned-kontrakt",
    component: StaticContractsPage,
  },
  terms: {
    path: "/om/vilkar",
    component: TermsPage,
  },
  aboutUpgrade: {
    path: "/om/oppgradering",
    component: AboutUpgradePage,
  },
  membershipPayment: {
    path: "/bli-medlem/betaling/:paymentId/:signature",
    component: MembershipPaymentPage,
  },
  becomeMember: {
    path: "/bli-medlem",
    component: BecomeMemberPage,
  },
  createStandardContract: {
    path: `/opprett/${getContractTypeKey(ContractType.Standard)}`,
    component: CreateStandardContractPage,
  },
  createPremiumContract: {
    path: `/opprett/${getContractTypeKey(ContractType.Premium)}`,
    component: CreatePremiumContractPage,
  },
  createSimpleContract: {
    path: `/opprett/${getContractTypeKey(ContractType.Simple)}`,
    component: CreateSimpleContractPage,
  },
  createMemberContract: {
    path: `/opprett/${getContractTypeKey(ContractType.Member)}`,
    component: CreateMemberContractPage,
  },
  createContract: {
    path: "/opprett/:type",
    component: CreateContractPage,
  },
};

export default StaticRoutes;
